// extracted by mini-css-extract-plugin
module.exports = {"languageOptionButton":"LanguageOptionButton_languageOptionButton__gQf2r","active":"LanguageOptionButton_active__ups_z","dark":"LanguageOptionButton_dark__MWcDB"};